import { useBaseStyles } from "routes/app/biens/style/styleBase";

export const useStyles = (theme) => ({
  ...useBaseStyles(theme),
  constructionYear: {
    display: "flex",
    padding: "15px!important",
  },
});
